<template>
  <!-- 轮播位置 -->
  <div id="figure" class="compontentsSwiper">
    <div id="title">{{ src }}</div>
    <div style="position: relative">
      <div
        class="swiper-container swiper1"
        style="width: 1250px; height: 350px"
      >
        <div class="swiper-wrapper" style="height: 100%">
          <div
            class="swiper-slide"
            v-for="item in doctorList"
            :key="item.id"
            @click="open(item.id)"
          >
            <div id="swiperImg">
              <img style="width: 100%; height: 100%" :src="item.src" />
            </div>
            <div id="swiperName">
              <div>{{ item.name }}</div>
              <div v-html="item.position"></div>
            </div>
          </div>
        </div>

        <!-- <div class="swiper-pagination"></div> -->
      </div>
      <div class="swiper-button-next button1" style="right: 12vw">
        <img
          style="width: 100%; height: 100%"
          src="../assets/img/right1.png"
          alt=""
        />
      </div>
      <!-- 白色 -->
      <div class="swiper-button-prev button2" style="left: 12vw">
        <img
          style="width: 100%; height: 100%"
          src="../assets/img/left1.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "../../node_modules/swiper/css/swiper.css";
export default {
  props: ["doctorList", "src"],
  data() {
    return {};
  },
  methods: {
    open(id) {
      this.$router.push({ name: "leadership", query: { id: id } });
      // if(this.$route.path == '/Survey'){
      //   this.$router.push({name:'leadership',query:{id:id}})
      // }else{
      //   this.$router.push({name:'doctorList',query:{id:id}})
      // }
    },
    start() {
      var mySwiper1 = new Swiper(".swiper1", {
        // slidesPerView: 5,
        slidesPerView: 5,
        // initialSlide:0,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        spaceBetween: 20,
        centeredSlides: false,
        autoplay:{delay: 1},
        speed: 3000,
        loop: true,
        freeMode: true,
        centeredSlidesBounds: true,
        navigation: {
          nextEl: ".button1",
          prevEl: ".button2",
        },
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
        },
      });
    },
  },
  // created() {
  //   this.start();
  // },
  mounted() {
    this.start();
  },
};
</script>
<style lang="less" scoped>
#swiperName {
  font-size: 1.9vh;
  font-weight: 600;
  // color:rgb(69, 109, 171)
}
@media screen and (max-width: 1680px) {
  /deep/ .swiper-button-next {
    right: 8vw !important;
  }
  /deep/ .swiper-button-prev {
    left: 8vw !important;
  }
}
@media screen and (max-width: 1440px) {
  /deep/ .swiper-button-next {
    right: 2vw !important;
  }
  /deep/ .swiper-button-prev {
    left: 2vw !important;
  }
}
@media screen and (max-width: 1366px) {
  /deep/ .swiper-button-next {
    right: 1vw !important;
  }
  /deep/ .swiper-button-prev {
    left: 1vw !important;
  }
}
.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
  display: none;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  display: none;
}
#figure {
  width: 100%;
  // position: relative;
  height: 500px;
  // background-image: url(../assets/img/jpg8.jpg);
  text-align: center;
}

#title {
  font-size: 30px;
  padding: 35px;
  padding-top: 50px;
  // font-weight: 600;
  font-family: dasongbiao;
  color: rgb(69, 109, 171);
}
</style>
<style lang="less">
.swiper-container-free-mode > .swiper-wrapper {
  -webkit-transition-timing-function: linear; /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
  margin: 0 auto;
}
.compontentsSwiper {
  .swiper-slide {
    // margin: 20px;
    background-image: url(../assets/img/jpg19_03.jpg);
    background-size: 100% 100%;
  }
  .swiper-slide-active {
    // color: #fff;
    background-color: #ffffff !important;
  }
  #swiperImg {
    width: 75%;
    height: 70%;
    margin: 20px auto;
    margin-bottom: 10px;
    /*background-image: url(../assets/img/s5dbfc85a93c43.jpg);*/
    background-size: 100% 100%;
  }
}
</style>
